import React, { useEffect } from "react";
import "./cocodi.css";
import { Link } from "react-router-dom";
import { etica_item } from "../../json/cocodi";

const Cocodi = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const linkStyle = {
    textDecoration: 'none'
  };

  return (
    <div className="container cocodi-container">
      <div className="row">
        <div className="col_12">
          <div className="cocodi_title">
            <h1>Comité de Control y Desempeño Institucional de la Secretaría de Agricultura y Desarrollo Rural del Estado de Hidalgo </h1>
          </div>
        </div>
      </div>

      <hr className="hr-gob" />
  
      <div class="row row-gob row-body">
								<div class="row-content">
  

      <hr className="hr-gob" />
      <iframe
        src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/cocodi.pdf"
        height="1000"
        width="1110"
      />
      </div>
     /</div> 
      
    </div>
  );
};

export default Cocodi;
